import { baseApi } from '@ibk/shared-config';
export const addressApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getAddressByCep: builder.query({
            query: cep => ({
                url: `/v1/address/${cep}`,
                method: 'GET',
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
    }),
});
export const { useGetAddressByCepQuery } = addressApi;
